import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  phoneNumber: '',
  password: '',
  accountType: null,
  verificationStep: 'initial',
  loading: false,
  error: null,
  // Invitation context for deep-link parameters
  invitationContext: {
    token: null,
    type: null,
    email: null,
    wyscoutId: null, // Integer - Wyscout player ID
    agentId: null, // Integer - Agent ID from invite_sent_by
    inviteSentBy: null, // Integer - Original invite_sent_by value
    senderType: null,
    agencyId: null, // Integer - Agency ID for agent invitations
    clubId: null, // Integer - Club ID for staff invitations
    mobile: null,
    isInvitationFlow: false
  },
  clubDetails: {
    name: '',
    licenseNumber: '',
    adminName: '',
    position: ''
  },
  agencyDetails: {
    agencyName: '',
    adminName: '',
    agencyLicenseNumber: '',
    logo: null
  },
  agentDetails: {
    fullName: '',
    licenseNumber: ''
  },
  playerDetails: {
    fullName: '',
    position: '',
    dateOfBirth: '',
    nationality: ''
  },
  staffDetails: {
    staff_type: '',
    role_type: '',
    works_for_club: true,
    additional_qualifications: '',
    additional_roles: ''
  },
  coachDetails: {
    name: '',
    licenseNumber: '',
    thesports_coach_id: ''
  },
  organizerDetails: {
    organizationName: '',
    organizationType: '',
    contactPersonName: '',
    licenseNumber: ''
  },
  lawyerDetails: {
    name: '',
    licenseNumber: '',
    specialization: ''
  }
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setSignupData: (state, action) => {
      return { ...state, ...action.payload };
    },
    setVerificationStep: (state, action) => {
      state.verificationStep = action.payload;
      state.error = null;
    },
    setInvitationContext: (state, action) => {
      state.invitationContext = { ...state.invitationContext, ...action.payload };
      state.isInvitationFlow = true;
    },
    clearInvitationContext: (state) => {
      state.invitationContext = initialState.invitationContext;
    },
    setClubDetails: (state, action) => {
      state.clubDetails = { ...state.clubDetails, ...action.payload };
    },
    setAgencyDetails: (state, action) => {
      state.agencyDetails = { ...state.agencyDetails, ...action.payload };
    },
    setAgentDetails: (state, action) => {
      state.agentDetails = { ...state.agentDetails, ...action.payload };
    },
    setPlayerDetails: (state, action) => {
      state.playerDetails = { ...state.playerDetails, ...action.payload };
    },
    setStaffDetails: (state, action) => {
      state.staffDetails = { ...state.staffDetails, ...action.payload };
    },
    setCoachDetails: (state, action) => {
      state.coachDetails = { ...state.coachDetails, ...action.payload };
    },
    setOrganizerDetails: (state, action) => {
      state.organizerDetails = { ...state.organizerDetails, ...action.payload };
    },
    setLawyerDetails: (state, action) => {
      state.lawyerDetails = { ...state.lawyerDetails, ...action.payload };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetSignup: () => initialState
  }
});

export const {
  setSignupData,
  setVerificationStep,
  setInvitationContext,
  clearInvitationContext,
  setClubDetails,
  setAgencyDetails,
  setAgentDetails,
  setPlayerDetails,
  setStaffDetails,
  setCoachDetails,
  setOrganizerDetails,
  setLawyerDetails,
  setLoading,
  setError,
  resetSignup
} = signupSlice.actions;

export default signupSlice.reducer; 